import { Heart } from 'lucide-react';
import { useFavorites } from '../context/FavoritesContext';

/**
 * Heart button that toggles a song's favourite status.
 * Signed-out users get a gentle "sign in" toast when they tap it.
 */
const HeartButton = ({ song, size = 'md', testId, className = '', onClick }) => {
  const { isFavorite, toggle } = useFavorites();
  const fav = isFavorite(song.id);
  const sizeCls = size === 'sm' ? 'w-8 h-8' : size === 'lg' ? 'w-11 h-11' : 'w-9 h-9';
  const iconCls = size === 'sm' ? 'w-3.5 h-3.5' : size === 'lg' ? 'w-5 h-5' : 'w-4 h-4';

  return (
    <button
      data-testid={testId || `heart-${song.id}`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggle(song);
        onClick?.(e);
      }}
      aria-label={fav ? 'Remove from Meri Pasand' : 'Add to Meri Pasand'}
      className={`${sizeCls} rounded-full flex items-center justify-center transition-all hover:bg-[#220A0A] ${fav ? 'text-[#FF007F]' : 'text-[#BFA5A5] hover:text-[#FF007F]'} ${className}`}
    >
      <Heart className={`${iconCls} ${fav ? 'fill-current' : ''} transition-all ${fav ? 'scale-110' : 'scale-100'}`} />
    </button>
  );
};

export default HeartButton;
